import React, { Component } from 'react'
import { BrowserRouter as Router, Route, NavLink } from 'react-router-dom'

import Home from './Home'
import Biography from './Biography'
import Contact from './Contact'
import PortfolioMenu from './PortfolioMenu'
import Intro from './Intro'
import Houses from './Houses'
import PortfolioPage from './PortfolioPage'
import Cronology from './Cronology'
import PortfolioMenuIntroMobile from './PortfolioMenuIntroMobile'
import PortfolioMenuIntroDesktop from './PortfolioMenuIntroDesktop'


var data = require('./db.json');


class MainMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      biography: [],
      cronology: [],
      contact: [],     
      interiors: [],
      furnitures: [],
      studies: [],
      houses: [],
      test: []
    }


    this.openNav = this.openNav.bind(this)
  }


  componentDidMount() {
    this.setState({
      biography: data.biography[0],
      cronology: data.cronology,
      contact: data.contact[0],     
      interiors: data.interiors[0],
      furnitures: data.furnitures[0],
      studies: data.studies[0],
      houses: data.houses
    })
  }

  openNav() {

    let x = document.getElementById("menu-principal");

    if (x.className === "menu-principal") {
      x.className += " menujs";
      document.getElementById("threeline-icon").innerHTML = "&Cross;";


    } else {
      x.className = "menu-principal";
      document.getElementById("threeline-icon").innerHTML = "<i class='fa fa-bars'></i>";
    }
  }

  render() {    
    return (
      <div>
        <Router>
          <div>
            <nav id="menu-principal" className="menu-principal">
              <ul>
                <li><NavLink onClick={this.openNav} activeClassName="active-home" className="home-link" activeClassName="active" exact to="/"><span className="bullet">•</span>início</NavLink></li>
                <li><NavLink onClick={this.openNav} activeClassName="active" exact to="/nota_biografica"><span className="bullet">•</span>nota biográfica</NavLink></li>
                <li><NavLink onClick={this.openNav} activeClassName="active" exact to="/portfolio/intro"><span className="bullet">•</span>portfolio</NavLink></li>
                <li><NavLink onClick={this.openNav} activeClassName="active" exact to="/contato"><span className="bullet">•</span>contato</NavLink></li>
                <li onClick={this.openNav} id="threeline-icon" className="threeline-icon"><i class="fa fa-bars"></i></li>
              </ul>
            </nav>
            <div className="wrapper2">
              <div className="page-content">
                <Route exact path='/nota_biografica' render={() => <Biography data={this.state.biography} />} />
                <Route exact path='/portfolio/intro' render={() => <PortfolioMenuIntroDesktop />} />
                <Route exact path='/portfolio/intro' render={() => <Intro/>} />
                <Route exact path='/portfolio/intro' render={() => <PortfolioMenuIntroMobile />} />
                <Route exact path='/contato' render={() => <Contact data={this.state.contact} />} />
                <Route exact path='/portfolio/casas' component={() => <PortfolioMenu />} />
                <Route exact path='/portfolio/casas' component={() => <Houses data={this.state.houses} />} />
                <Route exact path='/portfolio/interiores' component={() => <PortfolioMenu />} />
                <Route exact path='/portfolio/interiores' component={() => <PortfolioPage data={this.state.interiors} />} />
                <Route exact path='/portfolio/moveis' component={() => <PortfolioMenu />} />
                <Route exact path='/portfolio/moveis' component={() => <PortfolioPage data={this.state.furnitures} />} />
                <Route exact path='/portfolio/estudos' component={() => <PortfolioMenu />} />
                <Route exact path='/portfolio/estudos' component={() => <PortfolioPage data={this.state.studies} />} />
                <Route exact path='/portfolio/cronologia' component={() => <PortfolioMenu />} />
                <Route exact path='/portfolio/cronologia' component={() => <Cronology data={this.state.cronology} />} />
                <Route exact path='/' render={() => <Home />} />
              </div>
            </div>
          </div>
        </Router>
      </div>
    )
  }
}

export default MainMenu


// WEBPACK FOOTER //
// ./src/MainMenu.js